type WizardStepActionsProps = {
  onBack?: () => void;
  showBack?: boolean;
  backLabel?: string;
  primaryLabel: string;
  primaryLoadingLabel?: string;
  isLoading?: boolean;
  primaryType?: 'submit' | 'button';
  onPrimaryClick?: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
};

export function WizardStepActions({
  onBack,
  showBack = true,
  backLabel = 'Voltar',
  primaryLabel,
  primaryLoadingLabel,
  isLoading = false,
  primaryType = 'submit',
  onPrimaryClick,
  secondaryLabel,
  onSecondary,
}: WizardStepActionsProps) {
  return (
    <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top gap-2 flex-wrap">
      <div className="d-flex gap-2">
        {showBack && onBack && (
          <button
            type="button"
            className="btn btn-outline-secondary d-inline-flex align-items-center gap-1"
            onClick={onBack}
            disabled={isLoading}
          >
            <i className="bi bi-arrow-left" aria-hidden="true" />
            {backLabel}
          </button>
        )}
        {secondaryLabel && onSecondary && (
          <button
            type="button"
            className="btn btn-link text-muted"
            onClick={onSecondary}
            disabled={isLoading}
          >
            {secondaryLabel}
          </button>
        )}
      </div>
      <button
        type={primaryType}
        className="btn btn-primary px-4 d-inline-flex align-items-center gap-1"
        disabled={isLoading}
        onClick={primaryType === 'button' ? onPrimaryClick : undefined}
        style={{
          background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)',
          border: 'none',
          borderRadius: '50px',
          boxShadow: '0 4px 12px rgba(13, 110, 253, 0.3)',
        }}
      >
        {isLoading ? (primaryLoadingLabel ?? primaryLabel) : primaryLabel}
        {!isLoading && <i className="bi bi-arrow-right" aria-hidden="true" />}
      </button>
    </div>
  );
}
